/* istanbul ignore file */

import type { MutableRefObject } from 'react';
import { useEffect } from 'react';

const SCREEN_EDGE_PX = 10;

export const usePreventSwipeNavigation = <T extends Element | null>(
  ref: MutableRefObject<T | null>,
) => {
  useEffect(() => {
    const currentRef = ref.current;
    const onTouchStart = (e: Event) => {
      const pageX = (<TouchEvent>e).touches[0].pageX;
      if (pageX < SCREEN_EDGE_PX || pageX > window.innerWidth - SCREEN_EDGE_PX) {
        e.preventDefault();
      }
    };

    currentRef?.addEventListener('touchstart', onTouchStart);

    return () => currentRef?.removeEventListener('touchstart', onTouchStart);
  }, [ref]);
};
